import { GET } from './core';

export const getEndpointWithPrefix = (endpoint) => {
  return endpoint ? `/inbound-sms/${endpoint}` : '/inbound-sms';
};

// GET /v1.0/app/inbound-sms
// Plain paginated list, newest first. `clientId` scopes the results to a
// single client (needed for ROLE_CLIENT_CAMPAIGN_ADMINISTRATOR, who should
// only see their own client's messages) - omit it to get every client's
// messages, as ROLE_THYAGA_ADMINISTRATOR does.
export const getInboundSms = (token, page = 0, size = 20, clientId = null) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('size', size);
  if (clientId !== null && clientId !== undefined && clientId !== '') {
    params.append('clientId', clientId);
  }
  const endpoint = `${getEndpointWithPrefix()}?${params.toString()}`;
  return GET(endpoint, token);
};
